import api from "../api";

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.detail ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;

export const getPaymentPlansByAccount = async (accountId) => {
  const { data } = await api.get(`/api/payments/plans/screen/${accountId}/`);
  return data;
};

export const previewChangePlan = async ({ account_id, new_plan_code, billing_interval }) => {
  try {
    const { data } = await api.post(`/api/payments/preview-change-plan/`, {
      account_id,
      new_plan_code,
      billing_interval,
      provider_code: "stripe",
    });

    return data;
  } catch (error) {
    throw new Error(
      getErrorMessage(error, "No se pudo generar el preview.")
    );
  }
};

export const createSubscriptionIntent = async ({
  account_id,
  plan_code,
  billing_interval,
}) => {
  try {
    const { data } = await api.post("/api/payments/subscription-intent/", {
      account_id,
      plan_code,
      billing_interval,
      provider_code: "stripe",
    });

    return data;
  } catch (error) {
    throw new Error(
      getErrorMessage(error, "No se pudo iniciar la suscripción.")
    );
  }
};

export const changePlan = async ({ account_id, preview_id, billing_interval }) => {
  try {
    const { data } = await api.post(`/api/payments/change-plan/`, {
      account_id,
      preview_id,
      billing_interval,
      provider_code: "stripe",
    });

    return data;
  } catch (error) {
    throw new Error(
      getErrorMessage(error, "No se pudo cambiar el plan.")
    );
  }
};

export const getAccountSummary = async (accountId) => {
  const { data } = await api.get(`/api/payments/accounts/${accountId}/summary/`);
  return data;
};

export const getAccountInvoices = async (accountId) => {
  const { data } = await api.get(`/api/payments/accounts/${accountId}/invoices/`);
  return data;
};

export const getAccountEntitlement = async (accountId) => {
  const { data } = await api.get(`/api/payments/accounts/${accountId}/entitlement/`);
  return data;
};

export const getRechargePackages = async () => {
  const { data } = await api.get("/api/payments/recharge-packages/");
  return data;
};

export const retryPayment = async (accountId) => {
  try {
    const { data } = await api.post("/api/payments/retry-payment/", {
      account_id: accountId,
      provider_code: "stripe",
    });
    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "No se pudo reintentar el pago."));
  }
};

export const getPaymentMethods = async (accountId) => {
  try {
    const { data } = await api.get(`/api/payments/payment-methods/${accountId}/`);
    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "No se pudo obtener los métodos de pago."));
  }
};

export const createSetupIntent = async (accountId) => {
  try {
    const { data } = await api.post("/api/payments/setup-intent/", { account_id: accountId });
    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "No se pudo iniciar el proceso de guardado de tarjeta."));
  }
};

export const setDefaultPaymentMethod = async (accountId, paymentMethodId) => {
  try {
    const { data } = await api.post(`/api/payments/payment-methods/${accountId}/default/`, {
      payment_method_id: paymentMethodId,
    });
    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "No se pudo cambiar el método predeterminado."));
  }
};

export const detachPaymentMethod = async (accountId, paymentMethodId) => {
  try {
    const { data } = await api.post(`/api/payments/payment-methods/${accountId}/detach/`, {
      payment_method_id: paymentMethodId,
    });
    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "No se pudo eliminar el método de pago."));
  }
};

export const cancelSubscription = async (accountId) => {
  try {
    const { data } = await api.post("/api/payments/subscriptions/cancel/", {
      account_id: accountId,
    });
    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "No se pudo programar la baja."));
  }
};

export const createRechargeCheckout = async ({ account_id, package_code }) => {
  try {
    const { data } = await api.post("/api/payments/recharge-checkout/", {
      account_id,
      package_code,
      provider_code: "stripe",
    });
    return data;
  } catch (error) {
    throw new Error(getErrorMessage(error, "No se pudo iniciar la compra."));
  }
};
